import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CustomerTypeNamePipe } from './customer-type-name.pipe';
import { CustomerPaymentStatusNamePipe } from './customer-payment-status-name.pipe';
import { LanguageNamePipe } from './language-name.pipe';
import { CurrencyNamePipe } from './currency-name.pipe';
import { InvoiceMethodTypeNamePipe } from './invoice-method-type-name.pipe';
import { BillingModuleTypeNamePipe } from './billing-module-type-name.pipe';
import { PaymentMethodTypeNamePipe } from './payment-method-type-name.pipe';
import { BasicUsageChargeTypeNamePipe } from './basic-usage-charge-type-name.pipe';
import { TerminationPeriodTypeNamePipe } from './termination-period-type-name.pipe';
import { PackageTypeNamePipe } from './package-type-name.pipe';

@NgModule({
    imports: [CommonModule],
    declarations: [
        CustomerTypeNamePipe,
        CustomerPaymentStatusNamePipe,
        LanguageNamePipe,
        CurrencyNamePipe,
        InvoiceMethodTypeNamePipe,
        BillingModuleTypeNamePipe,
        PaymentMethodTypeNamePipe,
        BasicUsageChargeTypeNamePipe,
        TerminationPeriodTypeNamePipe,
        PackageTypeNamePipe,
    ],
    exports: [
        CustomerTypeNamePipe,
        CustomerPaymentStatusNamePipe,
        LanguageNamePipe,
        CurrencyNamePipe,
        InvoiceMethodTypeNamePipe,
        BillingModuleTypeNamePipe,
        PaymentMethodTypeNamePipe,
        BasicUsageChargeTypeNamePipe,
        TerminationPeriodTypeNamePipe,
        PackageTypeNamePipe,
    ],
})
export class CustomerBillingComponentsModule {}
